import { render } from "./ContentLoader.vue?vue&type=template&id=6e251dca&scoped=true"
import script from "./ContentLoader.vue?vue&type=script&lang=ts"
export * from "./ContentLoader.vue?vue&type=script&lang=ts"

import "./ContentLoader.vue?vue&type=style&index=0&id=6e251dca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e251dca"

export default script